import PropTypes from 'prop-types';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { useSnackbar } from 'notistack';
import Iconify from 'src/components/Iconify';
import { useAddDeploymentRing } from 'src/hooks/deploymentRing';
import { pagesText } from 'src/constants/pagesText';
import AddDeploymentRingForm from './AddDeploymentRingForm';

const AddDeploymentRingModal = ({ onClose }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { mutateAsync: addDeploymentRing, isLoading } = useAddDeploymentRing();

  const handleSubmit = async payload => {
    try {
      await addDeploymentRing(payload);
      enqueueSnackbar('Deployment ring added.', { variant: 'success', autoHideDuration: 3000 });
      onClose();
    } catch (error) {
      enqueueSnackbar(typeof error === 'string' && error ? error : pagesText.somethingWentWrong, {
        variant: 'error',
        autoHideDuration: 4000,
      });
    }
  };

  return (
    <Dialog
      open
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { backgroundColor: 'background.dialog' } }}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Iconify icon="mdi:shield-plus-outline" width={22} height={22} color="#87C8E0" />
        Add Deployment Ring
      </DialogTitle>
      <DialogContent>
        <AddDeploymentRingForm loading={isLoading} onCancel={onClose} onSubmit={handleSubmit} />
      </DialogContent>
    </Dialog>
  );
};

AddDeploymentRingModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default AddDeploymentRingModal;
